import React, { useState } from 'react';
import styled from 'styled-components';
import { DialogPlugin, Dropdown, MessagePlugin, Space } from 'tdesign-react';
import { connect } from 'react-redux';
import SvgIcon from '@/components/SvgIcon';
import JSONModal from '@/components/JSONModal';
// import PermWrapper from '@/components/PermWrapper';
import useDisableButton from '@/components/DisableWrapper/useDisableButton';
import Form from '@/components/Form';
import Dashboard from '../Dashboard';
import StartManage from './StartManage';

function Options({
  row,
  getDiffNode,
  getOptionRequests,
  doRefresh,
  resource,
  perms,
  clusterName,
  functionType,
}) {
  const [visibles, setVisibles] = useState({});
  const [jsonView, setJsonView] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [form] = Form.useForm();

  const diffNodes = getDiffNode(row, isEdit, form);
  const optionRequests = getOptionRequests(row);
  const { doRestart, doStop, getStatus, getParams } = optionRequests;

  const confirmBtn = useDisableButton({ content: '确定' });

  const running = [
    {
      value: '7',
      resource: `${resource}:config`,
      content: '配置',
    },
    {
      value: '3',
      resource: `${resource}:restart`,
      content: '重启',
    },
    {
      value: '4',
      resource: `${resource}:stop`,
      content: '停止',
    },
    {
      value: '5',
      resource: `${resource}:status`,
      content: '实时状态',
    },
    {
      value: '6',
      resource: `${resource}:params`,
      content: '实时参数',
    },
  ];
  // 就绪
  const create = [
    {
      value: '2',
      resource: `${resource}:start`,
      content: '启动',
    },
  ];
  // 停止
  const stop = [
    {
      value: '7',
      resource: `${resource}:config`,
      content: '配置',
    },
    {
      value: '3',
      resource: `${resource}:restart`,
      content: '重启',
    },
    {
      value: '5',
      resource: `${resource}:status`,
      content: '实时状态',
    },
    {
      value: '6',
      resource: `${resource}:params`,
      content: '实时参数',
    },
  ];
  // 异常
  const failed = [
    {
      value: '7',
      resource: `${resource}:config`,
      content: '配置',
    },
    {
      value: '3',
      resource: `${resource}:restart`,
      content: '重启',
    },
    {
      value: '4',
      resource: `${resource}:stop`,
      content: '停止',
    },
    {
      value: '5',
      resource: `${resource}:status`,
      content: '实时状态',
    },
    {
      value: '6',
      resource: `${resource}:params`,
      content: '实时参数',
    },
  ];

  const mapOptions = {
    running,
    create,
    stop,
    failed,
  };

  const options = mapOptions[row.status].filter((item) => perms.includes(item.resource));

  const hideAll = (refresh) => {
    setVisibles({});
    if (refresh) {
      doRefresh();
    }
  };

  const show = (item) => {
    setVisibles((visibles) => ({
      ...visibles,
      [item]: true,
    }));
  };

  const onSelect = async (value) => {
    switch (value) {
      case '1': // 包管理
        show('package');
        break;

      case '2': // 启动
        show('start');
        setIsEdit(false);
        break;

      case '3':
        {
          const dialog = DialogPlugin.confirm({
            header: '提示',
            theme: 'warning',
            body: '确定重启？',
            confirmBtn,
            onClose: () => dialog.hide(),
            onConfirm: async () => {
              try {
                dialog.update({
                  confirmBtn: { loading: true, content: '确定' },
                });
                await doRestart();
                MessagePlugin.success('操作成功！');
                dialog.hide();
                doRefresh();
              } catch (error) {
                console.trace(error);
                throw error;
              } finally {
                dialog.update({
                  confirmBtn: { loading: false, content: '确定' },
                });
              }
            },
          });
        }
        break;

      case '4':
        {
          const dialog = DialogPlugin.confirm({
            header: '提示',
            theme: 'warning',
            body: '确定停止？',
            confirmBtn,
            onClose: () => dialog.hide(),
            onConfirm: async () => {
              try {
                dialog.update({
                  confirmBtn: { loading: true, content: '确定' },
                });
                await doStop();
                MessagePlugin.success('操作成功！');
                dialog.hide();
                doRefresh();
              } catch (error) {
                console.trace(error);
                throw error;
              } finally {
                dialog.update({
                  confirmBtn: { loading: false, content: '确定' },
                });
              }
            },
          });
        }
        break;

      case '5':
        {
          const { data } = await getStatus();
          setJsonView({
            visible: true,
            title: '状态详情',
            json: data,
          });
        }
        break;

      case '6':
        {
          const { data } = await getParams();
          setJsonView({
            visible: true,
            title: '参数详情',
            json: data,
          });
        }
        break;
      case '7': // 更新
        show('start');
        setIsEdit(true);
        break;
      default:
        break;
    }
  };

  return (
    <>
      <Space size='small'>
        <Icon type='presentation-chart-line' onClick={() => show('chart')} />
        <Dropdown options={options} onClick={({ value }) => onSelect(value)}>
          <div>
            <Icon type='dots-vertical' />
          </div>
        </Dropdown>
      </Space>
      <Dashboard
        header={diffNodes.dashboardHeader}
        getChartsData={(params) => optionRequests.getChartsData(params, row)}
        visible={visibles.chart}
        handleClose={hideAll}
      />
      <StartManage
        diffNodes={diffNodes}
        visible={visibles.start}
        optionRequests={optionRequests}
        handleClose={hideAll}
        form={form}
        isEdit={isEdit}
        clusterName={clusterName}
        functionType={functionType}
      />
      <JSONModal
        visible={jsonView.visible}
        handleClose={() => setJsonView({})}
        json={jsonView.json}
        loading={jsonView.loading}
        title={jsonView.title}
      />
    </>
  );
}

export default connect((state) => ({
  perms: state.auth.perms,
}))(Options);

const Icon = styled(SvgIcon)`
  cursor: pointer;
  color: #194dff;
`;
